// extracted by mini-css-extract-plugin
module.exports = {"avatarWrapper":"ImageInput_avatarWrapper__KENKv","avatarHolder":"ImageInput_avatarHolder__2rEE9"};